<div class="modal-body" aria-labelledby="upsell-event-name">
    <a class="modal-image-top" (click)="closeModals()" [routerLink]="ENROLL_PC_ROUTE" [queryParams]="{enrollForward: Constants.ENROLL_FORWARD_CHECKOUT}">
        <h3 class="modal-title" id="upsell-event-name" translate="cart.enroll.pc.upsell.modal.title"></h3>
        <h4 class="subheading-1" translate="cart.enroll.pc.upsell.modal.subtitle"></h4>
    </a>
    <div class="modal-body-lower">
        <a class="button button-primary button-large" (click)="closeModals()" [routerLink]="ENROLL_PC_ROUTE" [queryParams]="{enrollForward: Constants.ENROLL_FORWARD_CHECKOUT}" translate="cart.enroll.pc.upsell.modal.primary.button"></a>
        <button class="button button-secondary button-large" (click)="goToLogin()" translate="cart.enroll.pc.upsell.modal.secondary.button"></button>
        <button class="button button-tertiary button-large" (click)="goToCheckout()" translate="cart.enroll.pc.upsell.modal.tertiary.button"></button>
    </div>
</div>
